export const PERSONAL = [
  {
    id: "01",
    nombre: "Ing. José A. Chacón",
    cargo: "Director Ejecutivo",
    email: "directorejecutivofenagh@gmail.com",
    telefono: "33977073",
    foto: "Empleados/JoseChacon.jpeg",
  },
  {
    id: "02",
    nombre: "Msc. Javier Barahona",
    cargo: "Asistente Técnico Administrativo",
    email: "javierbarahonahn2@gmail.com",
    telefono: "33158224",
    foto: "Empleados/JavierBarahona.jpeg",
  },
  {
    id: "03",
    nombre: "Msc. Maria Jose Romero",
    cargo: "Asistente Técnico Administrativo",
    email: "fenagh.oficial@gmail.com",
    telefono: "31470400",
    foto: "Empleados/MariaJose.jpeg",
  },
  {
    id: "04",
    nombre: "Kenia Castellanos",
    cargo: "Administradora",
    email: "admonfenagh1@gmail.com",
    telefono: "32156959",
    foto: "Empleados/KeniaCastellanos.jpeg",
  },
  {
    id: "05",
    nombre: "Kathy Sierra",
    cargo: "Jefe de Recaudo",
    email: "recaudo.fenagh@gmail.com",
    telefono: "32873844",
    foto: "Empleados/KathySierra.jpeg",
  },
  {
    id: "06",
    nombre: "Waldina Pon",
    cargo: "Oficial de Recaudo PROMDECA",
    email: "waldinaponfenagh@gmail.com",
    telefono: "31650656",
    foto: "Empleados/WaldinaPon.jpeg",
  },
  {
    id: "07",
    nombre: "Stephany Bonilla",
    cargo: "Oficial de Datos de Registro Genealógico",
    email: "registrogenealogicofenagh@gmail.com",
    telefono: "33110100",
    foto: "Empleados/StephanyBonilla.jpeg",
  },
  {
    id: "08",
    nombre: "Fredy Maradiaga",
    cargo: "Conserje",
    email: "",
    telefono: "",
    foto: "Empleados/FredyMaradiaga.jpeg",
  },
]

export const EMPRESAS = [
  { id: "01", siglas: "MSH", nombre: "Molino Harinero Sula" },
  { id: "02", siglas: "Walmart", nombre: "Walmart Honduras" },
  { id: "03", siglas: "Leyde", nombre: "Leche y Derivados" },
  { id: "04", siglas: "LACTHOSA", nombre: "Lácteos de Honduras S.A" },
  { id: "05", siglas: "DINANT", nombre: "Corporación Dinant" },
]

export const JUNTA = [
  { id: "01", nombre: "Héctor Alberto Ferreira", cargo: "Presidente" },
  { id: "02", nombre: "Mario Alberto Lovo", cargo: "Vicepresidente" },
  { id: "03", nombre: "Rigoberto Erazo Oseguera", cargo: "Secretario" },
  { id: "04", nombre: "Gilberto Moreno Alvarado", cargo: "Tesorero" },

  { id: "05", nombre: "José Manuel España", cargo: "Vocal I" },
  { id: "06", nombre: "Wilmer Barahona", cargo: "Vocal II" },
  { id: "07", nombre: "Leopoldo Duran Puerto", cargo: "Vocal III" },
  { id: "07", nombre: "Juan Valladares Salgado", cargo: "Vocal IV" },

  { id: "01", nombre: "Juan José Sabillón Cruz", cargo: "Junta Fiscalizadora" },
  { id: "09", nombre: "Gerardo Guillén", cargo: "Junta Fiscalizadora" },
  { id: "10", nombre: "Norman Fasquelle", cargo: "Junta Fiscalizadora" },

  /* {id: "08", nombre: "Francisco Sandoval", cargo:  "Asesor"},
  {id: "08", nombre: "Pedro Mendoza", cargo:  "Asesor"},
  {id: "11", nombre: "Víctor Wilson", cargo:  "Asesor"},
  {id: "12", nombre: "Pablo Sierra", cargo:  "Asesor"},
  {id: "16", nombre: "Denis Avendaño", cargo:  "Asesor"},
  {id: "13", nombre: "Justo Rene Martínez.", cargo:  "Asesor"},*/
]

export const ASOCIACIONES = [
  {
    id: "01",
    asociacion: "AGAFAM",
    nombre: "Asociación de Ganaderos y Agricultores de Francisco Morazán ",
    presidente: "Roberto Gallardo",
    telefono: "9961-5644",
  },
  {
    id: "02",
    asociacion: "AGAA",
    nombre: "Asociación de Ganaderos y Agricultores de Atlántida",
    presidente: "Margarito Vásquez Laínez",
    telefono: "9583-2518",
  },
  {
    id: "03",
    asociacion: "AGADES",
    nombre: "Asociación de Ganaderos y Agricultores de Saba, Colón",
    presidente: "Juan Edgardo Ruíz",
    telefono: "9945-9948",
  },
  {
    id: "04",
    asociacion: "AGABO",
    nombre: "Asociación de Ganaderos y Agricultores de Bonito Oriental ",
    presidente: "Clemente Cardona",
    telefono: "9944-3744",
  },
  {
    id: "05",
    asociacion: "AAGI",
    nombre: "Asociación de Ganaderos y Agricultores de Ilanga ",
    presidente: "Lizardo Perez", //"Mario Barralaga",//
    telefono: "9970-5629", //"9930-0954"//
  },
  {
    id: "06",
    asociacion: "AGAC",
    nombre: "Asociación de Ganaderos y Agricultores de Copán ",
    presidente: "Milton Yanuario Santos",
    telefono: "9452-0059",
  },
  {
    id: "07",
    asociacion: "AGAS",
    nombre: "Asociación de Ganaderos y Agricultores de Sula",
    presidente: "Hector Ferreira",
    telefono: "9995-1010",
  },
  {
    id: "08",
    asociacion: "ANAPOH",
    nombre: "Asociación Nacional de Porcicultores de Honduras ",
    presidente: "Allan Reyes",
    telefono: "9991-4033",
  },

  {
    id: "09",
    asociacion: "PROAVIH",
    nombre: " Productores Avícolas de Honduras",
    presidente: "Ixim David",
    telefono: "2557-4636",
  },
  {
    id: "10",
    asociacion: "ANAVIH",
    nombre: "Asociación Nacional de Avicultores de Honduras",
    presidente: "Norman Fasquelle", //Luis Eduardo Valle Coello//
    telefono: "2550-2343", //"9977-3759"//
  },
  {
    id: "11",
    asociacion: "AGACH",
    nombre: "Asociación de Ganaderos y Agricultores de Choluteca",
    presidente: "Mario Argeñal",
    telefono: "3194-7312",
  },
  {
    id: "12",
    asociacion: "AGASM",
    nombre: "Asociación de Ganaderos y Agricultores de San Marcos",
    presidente: "Jose Antonio Calderon Lopez",
    telefono: "9624-5503",
  },
  {
    id: "13",
    asociacion: "ANDAH",
    nombre: "Asociación Nacional de Acuicultores de Honduras ",
    presidente: "Ismael Wong Cantera",
    telefono: "3390-8927",
  },
  {
    id: "14",
    asociacion: "ADAGO",
    nombre: "Asociación de Ganaderos y Agricultores de Oriente",
    presidente: "Ricardo Emilio Arias",
    telefono: "9785-1377",
  },
  {
    id: "15",
    asociacion: "AGADI",
    nombre: "Asociación de Ganaderos y Agricultores de Intibucá ",
    presidente: "Hugo Eduardo Vásquez",
    telefono: "9970-7682",
  },
  {
    id: "16",
    asociacion: "AGADEG",
    nombre: "Asociación de Ganaderos y Agricultores de Gracias ",
    presidente: "Adrián Castro",
    telefono: "9931-6397",
  },
  {
    id: "17",
    asociacion: "AGAO",
    nombre: "Asociación de Ganaderos y Agricultores de Olancho",
    presidente: "Angel Hernan Eveline",
    telefono: "9792-0651",
  },
  {
    id: "18",
    asociacion: "SAGO",
    nombre: "Sociedad de Agricultores y Ganaderos de Olanchito",
    presidente: " Juan José Molina Puerto",
    telefono: "9873-4263",
  },
  {
    id: "19",
    asociacion: "AGAY",
    nombre: "Asociación de Ganaderos y Agricultores de Yoro",
    presidente: "Roger Padilla",
    telefono: "9455-1826",
  },
  {
    id: "20",
    asociacion: "PROGRANO",
    nombre: "Productores de Granos Básicos",
    presidente: "Dulio Medina",
    telefono: "3380-0916",
  },
  {
    id: "21",
    asociacion: "APAH",
    nombre: "Asociación de Productores de Azúcar Honduras ",
    presidente: "Robert Vinelli",
    telefono: "2239-4933",
  },
  {
    id: "22",
    asociacion: "CAFOGAH",
    nombre: "Cámara de Fomento Ganadero de Honduras",
    presidente: "Mario Lovo",
    telefono: "9973-4020",
  },

  {
    id: "23",
    asociacion: "AHPROCEM",
    nombre: "Asociación Hondureña de Procesadores de Carne y Embutidos ",
    presidente: "María Fernanda Ortega",
    telefono: "2564-9470",
  },
  {
    id: "24",
    asociacion: "CAHLE",
    nombre: "Asociación de Beneficio Mutuo Cámara Hondureña de la Leche",
    presidente: "Gilberto Moreno",
    telefono: "9979-9487", //"9995-1010"//
  },
  {
    id: "25",
    asociacion: "AGATC",
    nombre: "Asociación de Ganadores y Agricultores de Tocoa,Colón",
    presidente: "Rosel Ramon Matute",
    telefono: "9566-9695",
  },
  {
    id: "26",
    asociacion: "AGAG",
    nombre: "Asociación de Ganadores y Agricultores de Guaimaca",
    presidente: "Armando Chavez", //"Jonathan Efren Ayala Artica ",//
    telefono: "9653-2419",
  },
  {
    id: "27",
    asociacion: "ASOPROSALH",
    nombre: "Asociación de Productores Saleros de Honduras",
    presidente: "Ivan Osorio Sierra", //Marcio Molina
    telefono: "3354-1184", //3336-0000
  },
  {
    id: "28",
    asociacion: "AHPROCAFE",
    nombre: "Asociación Hondureña de Productores de Café",
    presidente: "Pedro Mendoza",
    telefono: "9990-6896",
  },
  {
    id: "29",
    asociacion: "APROLECHE",
    nombre: "Asociación de Procesadores de Leche",
    presidente: "Christian Nehring",
    telefono: "2231-1102",
  },

  {
    id: "30",
    asociacion: "AGABRUL",
    nombre: "Asociación de Agricultores y Ganadores de Brus Laguna  ",
    presidente: "Juan Angel Aguilar",
    telefono: "9738-0158",
  },

  {
    id: "31",
    asociacion: "ASPAH",
    nombre: "Asociación de Productores de Aguacate de Honduras",
    presidente: "Carlos Miguel Robleto",
    telefono: "9888-1320",
  },
  {
    id: "32",
    asociacion: "AGAVI",
    nombre: "Asociación de Ganaderos y Agricultores de Villanueva",
    presidente: "Jaime Vidal Hernández Matta",
    telefono: "9452-5344",
  },
  {
    id: "33",
    asociacion: "AGAV",
    nombre: "Asociación de Ganaderos y Agricultores de Valle",
    presidente: "Jose Everth Rubio ",
    telefono: "9614-4410",
  },

  {
    id: "34",
    asociacion: "AGASAG ",
    nombre: "Asociación de Ganaderos y Agriculores de Sabanagrande",
    presidente: "Sixto Amador",
    telefono: "3313-4220",
  },

  {
    id: "35",
    asociacion: "AGAT ",
    nombre: "Asociación de Ganaderos y Agricultores de Tela",
    presidente: "Melvin Lopez",
    telefono: "9950-6327",
  },

  {
    id: "36",
    asociacion: "AGASE",
    nombre: "Asociación de Ganaderos y Agricultores de San Esteban",
    presidente: "Edgar Oliva",
    telefono: "9838-9616",
  },
  {
    id: "37",
    asociacion: "APROJOCON",
    nombre:
      "Asociación de Productores Agropecuarios y Procesadores de Lácteos de Jocón, Yoro",
    presidente: "Rosel Edgardo Galeas",
    telefono: "9985-0548",
  },
  {
    id: "38",
    asociacion: "AGAMPA",
    nombre: "Asociación de Ganaderos y Agricultores del Paraíso",
    presidente: "José Eliobardo Amador",
    telefono: "9584-1411",
  },
  {
    id: "39",
    asociacion: "AGATRO",
    nombre: "Asociación de Ganaderos y Agricultores de Trojes",
    presidente: "Carlos Guanergy",
    telefono: "9523-0866",
  },

  {
    id: "40",
    asociacion: "AGAPCO",
    nombre: "Asociacion de Ganaderos y Agricultores Puerto Cortés y Omoa",
    presidente: "Eduardo Jallu",
    telefono: "9918-9034",
  },
  {
    id: "41",
    asociacion: "AGAMI",
    nombre: "Asociación de Ganaderos y Agricultores de la Margen Izquierda",
    presidente: "Hermes Leonel Soto",
    telefono: "9897-4919",
  },
  {
    id: "42",
    asociacion: "AGACO",
    nombre: " Asociacion de Ganaderos y Agricultores de Olancho",
    presidente: "Mario Ramón Lobo Rosa",
    telefono: "9509-1090",
  },
  {
    id: "43",
    asociacion: "AGAAO",
    nombre: "Asociación de Ganaderos y Agricultores de  Arimis,Olancho",
    presidente: "Angel Zelaya",
    telefono: "9511-2853",
  },
  {
    id: "44",
    asociacion: "AGADEL",
    nombre: " Asociación de Ganaderos y Agricultores de Lepaera",
    presidente: "",
    telefono: "",
  },
  {
    id: "45",
    asociacion: "AGAVALE",
    nombre: "Asociación de Ganaderos Y Agricultores Arizona y Valle de Lean",
    presidente: "Tulio Lainez",
    telefono: "9817-1697",
  },

  {
    id: "46",
    asociacion: "PALSA",
    nombre: "Palmas San Alejo",
    presidente: "Andres Gonzáles",
    telefono: "2429-0013",
  },
  {
    id: "47",
    asociacion: "AGROPALMA",
    nombre: "Agroindustrial Palma Real ",
    presidente: "Jorge Alberto Bulnes",
    telefono: "2429-0013",
  },
  {
    id: "48",
    asociacion: "MSH",
    nombre: "Molino Harinero de Sula",
    presidente: "Daniel Erza Goldstein Anhalt",
    telefono: "2566-2587",
  },
  {
    id: "49",
    asociacion: "DINANT",
    nombre: "Corporacion Dinant",
    presidente: "Miguel Mauricio Facusse",
    telefono: "",
  },
]
